module.exports = __webpack_public_path__ + "files/96a5136233f5dda6e402fadc73bbefba.png";